import { useQuery } from 'react-query';
import { getUserAddress } from '../api/getUserAddress';

const useUserAddress = () => {
  const { data, isLoading, error, refetch } = useQuery('userAddress', getUserAddress, {
    refetchOnWindowFocus: true,
    staleTime: 50000,
  });

  return { data, isLoading, error, refetch };
};

export default useUserAddress;
